// import person1 from "../../assets/images/person.jpg";

// 4th year 
import Abhay from "../../assets/images/team/4thYear/Abhay.jpg";
import Abhinavgaur from "../../assets/images/team/4thYear/Abhinavgaur.jpg";
import Aditya from "../../assets/images/team/4thYear/Aditya.jpg"
import AyushJaiswal from "../../assets/images/team/4thYear/AyushJaiswal.jpg"
import AyushKannaujiya from "../../assets/images/team/4thYear/AyushKannaujiya.jpeg"
import AyushSrivastava from "../../assets/images/team/4thYear/AyushSrivastava.jpg"
import Deeksha from "../../assets/images/team/4thYear/Deeksha.jpg"
import Harsh from "../../assets/images/team/4thYear/HarshKumar.png"
import Hritik from "../../assets/images/team/4thYear/Hritik.jpg"
import Jyoti from "../../assets/images/team/4thYear/Jyoti.jpg"
import Mayank from "../../assets/images/team/4thYear/Mayank.jpg"
import Mustafa from "../../assets/images/team/4thYear/Mustafa.jpg"
import Nutan from "../../assets/images/team/4thYear/Nutan.jpg"
import Sam3 from "../../assets/images/team/4thYear/Samriddhi.jpg"

import Tanya from "../../assets/images/team/4thYear/Tanya.jpg"
import Ujjwal from "../../assets/images/team/4thYear/Ujjawal.jpg"
import Vanshika from "../../assets/images/team/4thYear/Vanshika.jpg"
import Yuga from "../../assets/images/team/4thYear/Yuga.jpg"

// 3rd year
import AdityaSingh from "../../assets/images/team/3rdYear/AdityaSingh.jpg";
import AryanMishra from "../../assets/images/team/3rdYear/AryanMishra.jpg";
import GaurishaSharma from "../../assets/images/team/3rdYear/GaurishaSharma.jpeg";
import KrishnaAgarwal from "../../assets/images/team/3rdYear/KrishnaAgarwal.jpeg";
import Love from "../../assets/images/team/3rdYear/Love.jpg";
import Naman from "../../assets/images/team/3rdYear/Naman.png";
import Navneet from "../../assets/images/team/3rdYear/Navneet.jpg";
import Nehal from "../../assets/images/team/3rdYear/Nehal.jpg";
import Sarika from "../../assets/images/team/3rdYear/Sarika.webp";
import Satyam from "../../assets/images/team/3rdYear/Satyam.png";
import Shivansh from "../../assets/images/team/3rdYear/Shivansh.jpg";
import Soumya from "../../assets/images/team/3rdYear/Soumya.jpeg";
import Trisha from "../../assets/images/team/3rdYear/Trisha.jpg";
import VanshikaSinghwal from "../../assets/images/team/3rdYear/VanshikaSinghwal.jpeg";


export const TeamData = [
  // ================= 4TH YEAR =================
  {
    id: 66,
    year: 4,
    domain: 5,
    cardName: "Abhay Singh",
    cardDesignation: "UI/UX Designing",
    image: Abhay,
    links: {
      github: "https://github.com/Abhay0-0-01",
      linkedin: "/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 67,
    year: 4,
    domain: 5,
    cardName: "Abhinav Gaur",
    cardDesignation: "UI/UX Designing",
    image: Abhinavgaur,
    links: {
      github: "https://github.com/abhinav048",
      linkedin: "https://www.linkedin.com/in/abhinav-gaur-72a647330/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 68,
    year: 4,
    domain: 1,
    cardName: "Aditya Sanskar",
    cardDesignation: "Web Development",
    image: Aditya,
    links: {
      github: "https://github.com/Aditya7880900936",
      linkedin: "https://www.linkedin.com/in/aditya-sanskar-srivastav-a13b08327/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 69,
    year: 4,
    domain: 1,
    cardName: "Ayush Jaiswal",
    cardDesignation: "Web Development",
    image: AyushJaiswal,
    links: {
      github: "https://github.com/Cybernerd1/",
      linkedin: "https://www.linkedin.com/in/ayushjaiswal0/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 70,
    year: 4,
    domain: 1,
    cardName: "Ayush Kannaujiya",
    cardDesignation: "Web Development",
    image: AyushKannaujiya,
    links: {
      github: "https://github.com/iyush05",
      linkedin: "https://www.linkedin.com/in/ayushkannaujiya/",
      instagram: "/",
      behance: "/",
      twitter: "https://x.com/iyush05/",
    },
  },
  {
    id: 71,
    year: 4,
    domain: 2,
    cardName: "Ayush Srivastava",
    cardDesignation: "Machine Learning",
    image: AyushSrivastava,
    links: {
      github: "https://github.com/HiddenSquid0622",
      linkedin: "https://www.linkedin.com/in/ayush-srivastava-40a5a531b/",
      instagram: "https://www.instagram.com/ayushsrivastava907/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 72,
    year: 4,
    domain: 5,
    cardName: "Deeksha Gangwar",
    cardDesignation: "UI/UX Designing",
    image: Deeksha,
    links: {
      github: "https://github.com/Gangwardeeksha",
      linkedin: "https://www.linkedin.com/in/deeksha-gangwar-5842812aa/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 73,
    year: 4,
    domain: 1,
    cardName: "Harsh Kumar",
    cardDesignation: "Web Development",
    image: Harsh,
    links: {
      github: "https://github.com/devlopharsh",
      linkedin: "https://www.linkedin.com/in/harsh-kumar-31391a31a/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 74,
    year: 4,
    domain: 1,
    cardName: "Hritik Raj",
    cardDesignation: "Web Development",
    image: Hritik,
    links: {
      github: "https://github.com/HritikRaj2",
      linkedin: "https://in.linkedin.com/in/hritik-raj-paradox/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 75,
    year: 4,
    domain: 2,
    cardName: "Jyoti Pundir",
    cardDesignation: "Machine Learning",
    image: Jyoti,
    links: {
      github: "https://github.com/Jyoti21-git",
      linkedin: "https://www.linkedin.com/in/jyoti-pundir-16b608246/",
      instagram: "https://www.instagram.com/jyoti_lovee21/profilecard/?igsh=cGR4OHMxNDJ4NXFp",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 76,
    year: 4,
    domain: 1,
    cardName: "Mayank Sharma",
    cardDesignation: "Web Development",
    image: Mayank,
    links: {
      github: "https://github.com/Mayank356153",
      linkedin: "https://www.linkedin.com/in/mayank-sharma-526a66301/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 77,
    year: 4,
    domain: 2,
    cardName: "Mustafa Hussain",
    cardDesignation: "Machine Learning",
    image: Mustafa,
    links: {
      github: "https://github.com/Mustafa11300",
      linkedin: "https://www.linkedin.com/in/mustafa-hussain-b07866296/",
      instagram: "https://www.instagram.com/charismatic_enigma_?igsh=MXE5NWFxZnVqdnhwbw==",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 78,
    year: 4,
    domain: 3,
    cardName: "Nutan Kumar",
    cardDesignation: "App Development",
    image: Nutan,
    links: {
      github: "https://github.com/Nutan-Kum12",
      linkedin: "https://www.linkedin.com/in/nutan-kumar-7b9b05329/",
      instagram: "/",
      behance: "/",
      twitter: "https://x.com/Raushan27260703/",
    },
  },
  {
    id: 79,
    year: 4,
    domain: 1,
    cardName: "Samriddhi Yadav",
    cardDesignation: "Web Development",
    image: Sam3,
    links: {
      github: "https://github.com/Samriddhiy",
      linkedin: "https://www.linkedin.com/in/samriddhi-yadav-8513922a6/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 81,
    year: 4,
    domain: 4,
    cardName: "Tanya Malik",
    cardDesignation: "Managerial",
    image: Tanya,
    links: {
      github: "https://github.com/itanyamalik",
      linkedin: "https://www.linkedin.com/in/tanya-malik-202bb2328/",
      instagram: "/",
      behance: "/",
      twitter: "https://x.com/itanyamalik19/",
    },
  },
  {
    id: 82,
    year: 4,
    domain: 5,
    cardName: "Ujjwal Singh",
    cardDesignation: "UI/UX Designing",
    image: Ujjwal,
    links: {
      github: "/",
      linkedin: "https://www.linkedin.com/in/ujjwal-singh-a5066431b/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 83,
    year: 4,
    domain: 3,
    cardName: "Vanshika Pandey",
    cardDesignation: "App Development",
    image: Vanshika,
    links: {
      github: "https://github.com/Vanshika140404",
      linkedin: "https://www.linkedin.com/in/vanshika-pandey-9744542a8/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 84,
    year: 4,
    domain: 3,
    cardName: "Yuga Jaiswal",
    cardDesignation: "App Development",
    image: Yuga,
    links: {
      github: "https://github.com/YugaJ7",
      linkedin: "https://www.linkedin.com/in/yuga-jaiswal/",
      instagram: "https://www.instagram.com/yuga.j7/",
      behance: "/",
      twitter: "https://x.com/yugaj7/",
    },
  },

  // ================= 3RD YEAR =================
  {
    id: 96,
    year: 3,
    domain: 2,
    cardName: "Aditya Singh",
    cardDesignation: "Machine Learning",
    image: AdityaSingh,
    objectPosition: "center 15%",
    imageStyle: {
      objectPosition: "center 15%",
    },
    links: {
      github: "https://github.com/aditya90001",
      linkedin: "https://www.linkedin.com/in/aditya-singh-b2b0bb326/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 90,
    year: 3,
    domain: 5,
    cardName: "Aryan Mishra",
    cardDesignation: "UI/UX Designing",
    image: AryanMishra,
    links: {
      github: "https://github.com/mishraaryan6387",
      linkedin: "https://www.linkedin.com/in/aryan-mishra-770738321?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 98,
    year: 3,
    domain: 3,
    cardName: "Gaurisha Sharma",
    cardDesignation: "App Development",
    image: GaurishaSharma,
    objectPosition: "center 32%",
    imageStyle: {
      objectPosition: "center 32%",
    },
    links: {
      github: "https://github.com/gaurishasharma",
      linkedin: "https://www.linkedin.com/in/gaurisha-sharma-35169631b?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 88,
    year: 3,
    domain: 3,
    cardName: "Krishna Agarwal",
    cardDesignation: "App Development",
    image: KrishnaAgarwal,
    objectPosition: "center 8%",
    imageStyle: {
      objectPosition: "center 8%",
    },
    links: {
      github: "https://github.com/krishnaaarwal",
      linkedin: "https://www.linkedin.com/in/krishna-agarwal-9b2a06367/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 87,
    year: 3,
    domain: 1,
    cardName: "Love Varshney",
    cardDesignation: "Web Development",
    image: Love,
    links: {
      github: "https://github.com/lovevarshney2007",
      linkedin: "https://www.linkedin.com/in/love-varshney7002",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 93,
    year: 3,
    domain: 1,
    cardName: "Naman Srivastava",
    cardDesignation: "Web Development",
    image: Naman,
    objectPosition: "center 12%",
    imageStyle: {
      objectPosition: "center 12%",
    },
    links: {
      github: "https://github.com/Naman354",
      linkedin: "https://www.linkedin.com/in/naman-srivastava-connect",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 85,
    year: 3,
    domain: 1,
    cardName: "Navneet Sinha",
    cardDesignation: "Web Development",
    image: Navneet,
    objectPosition: "center 0%",
    imageStyle: {
      objectPosition: "center 0%",
    },
    links: {
      github: "https://github.com/Neet2516",
      linkedin: "https://www.linkedin.com/in/navneet-sinha-ba0853375/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 97,
    year: 3,
    domain: 2,
    cardName: "Nehal Jain",
    cardDesignation: "Machine Learning",
    image: Nehal,
    links: {
      github: "https://github.com/nehaljain21",
      linkedin: "https://www.linkedin.com/in/nehal-jain-nj",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 86,
    year: 3,
    domain: 1,
    cardName: "Sarika Maurya",
    cardDesignation: "Web Development",
    image: Sarika,
    links: {
      github: "https://github.com/SarikaM07",
      linkedin: "https://www.linkedin.com/in/sarika-maurya-89ba043aa?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 89,
    year: 3,
    domain: 5,
    cardName: "Satyam Paswan",
    cardDesignation: "UI/UX Designing",
    image: Satyam,
    links: {
      github: "https://github.com/satyamp11",
      linkedin: "https://www.linkedin.com/in/satyamp11/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 91,
    year: 3,
    domain: 1,
    cardName: "Shivansh Kumar",
    cardDesignation: "Web Development",
    image: Shivansh,
    objectPosition: "center 40%",
    imageStyle: {
      objectPosition: "center 40%",
    },
    links: {
      github: "https://github.com/shivansh6317",
      linkedin: "https://www.linkedin.com/in/shivansh-kumar-875709382?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 95,
    year: 3,
    domain: 3,
    cardName: "Soumya Gupta",
    cardDesignation: "App Development",
    image: Soumya,
    objectPosition: "center 12%",
    imageStyle: {
      objectPosition: "center 12%",
    },
    links: {
      github: "https://github.com/soumya12062013",
      linkedin: "https://www.linkedin.com/in/soumya-gupta-dec06/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 92,
    year: 3,
    domain: 5,
    cardName: "Trisha Singh",
    cardDesignation: "UI/UX Designing",
    image: Trisha,
    objectPosition: "center 30%",
    imageStyle: {
      objectPosition: "center 30%",
    },
    links: {
      github: "https://github.com/Trishasinghof-art",
      linkedin: "https://www.linkedin.com/in/trisha-singh-431185371/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
  {
    id: 94,
    year: 3,
    domain: 5,
    cardName: "Vanshika Singhwal",
    cardDesignation: "UI/UX Designing",
    image: VanshikaSinghwal,
    links: {
      github: "/",
      linkedin: "https://www.linkedin.com/in/vanshika-singhwal-230554345/",
      instagram: "/",
      behance: "/",
      twitter: "/",
    },
  },
];
